import React, { createContext, useContext } from 'react';

/** Per-request signal that this MCP preview should resolve the DRAFT event design (server sets it only for `?view=draft`). See MCP_PREVIEW.md#cache-key-parity. */
const McpPreviewForceDraftContext = createContext<boolean>(false);

export const McpPreviewForceDraftProvider: React.FC<{ forceDraft?: boolean; children: React.ReactNode }> = ({ forceDraft = false, children }) => (
  <McpPreviewForceDraftContext.Provider value={!!forceDraft}>{children}</McpPreviewForceDraftContext.Provider>
);

export const useMcpPreviewForceDraft = (): boolean => useContext(McpPreviewForceDraftContext);
